// /Zustand/useProfileStore.js
import { create } from 'zustand';

const useProfileStore = create((set) => ({
  imageUrl: '',
  setImageUrl: (url) => set({ imageUrl: url }),
}));

export default useProfileStore;